import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers } from 'recompose';
import { Form } from '@sparefoot/react-core';

import { Input } from 'components/core/Input';
import { Button } from 'components/core/Button';
import { H3 } from 'components/core/Typography';
import { Row, Column } from 'components/core/Page';
import {
	Modal,
	ModalBody,
	ModalTitle,
	ModalFooter,
} from 'components/core/Modal';

import './SearchModal.scss';

export const enhance = compose(
	withState('location', 'setLocation', ''),
	withHandlers({
		onLocationChange:
			({ setLocation }) =>
			({ target }) =>
				setLocation(target.value),
		handleSearch:
			({ onSearch, location }) =>
			() =>
				onSearch({ locationParams: { location } }),
	}),
);

export function SearchModal({
	showing,
	onClose,
	onLocationChange,
	location,
	handleSearch,
}) {
	return (
		<Modal
			className="search-modal"
			showing={showing}
			onClose={onClose}
		>
			<Form
				action="/search"
				successLabel="success"
				failureLabel="fail"
				onSubmit={handleSearch}
			>
				<ModalTitle>
					<H3
						last
						size="medium"
					>
						Search Units
					</H3>
				</ModalTitle>
				<ModalBody>
					<Input
						id="search-modal-input"
						name="location"
						label="Zip or City Name"
						placeholder="Enter Zip or City Name"
						onChange={onLocationChange}
						value={location}
					/>
				</ModalBody>
				<ModalFooter>
					<Row>
						<Column small={6}>
							<Button
								type="submit"
								primary
								fullWidth
							>
								Find Units
							</Button>
						</Column>
						<Column small={6}>
							<Button
								secondary
								fullWidth
								onClick={onClose}
							>
								Cancel
							</Button>
						</Column>
					</Row>
				</ModalFooter>
			</Form>
		</Modal>
	);
}

SearchModal.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	location: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	onLocationChange: PropTypes.func.isRequired,
	showing: PropTypes.bool,
};

export default enhance(SearchModal);
